import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import { Grid } from '@mui/material';
import Dashboard from 'layouts/V2/Dashboard';
import PropTypes from 'prop-types';

import styles from '../Guesty/guesty.module.css';

import ConfigureBrand from '../Guesty/components/ConfigureBrand';
import EditDefaultBrand from '../Guesty/components/EditDefaultBrand';
import LodgifyPage from './LodgifyPage';

function LodgifyHome(props) {
    return (
        <Grid>
            <Switch>
                <Route
                    path={`${props.match.path}`}
                    render={() => <LodgifyPage {...props} integrationName="lodgify" />}
                    exact
                />
                <Route
                    path={`${props.match.path}/brands/:uuid/edit`}
                    render={() => (
                        <Dashboard mainContainerStyles={styles.editBrandWrapper}>
                            <EditDefaultBrand {...props} integrationName="lodgify" />{' '}
                        </Dashboard>
                    )}
                    exact
                />
                <Route
                    path={`${props.match.path}/brands/:uuid`}
                    render={() => <ConfigureBrand {...props} integrationName="lodgify" />}
                    exact
                />
            </Switch>
        </Grid>
    );
}

LodgifyHome.propTypes = {
    match: PropTypes.object,
};

export default withRouter(LodgifyHome);
